import React, { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import IcomoonReact from 'icomoon-react'
import classNames from 'classnames'
import { useGlobalContext } from 'src/stores/GlobalContext'
import UserImage from 'src/components/Elements/UserImage'
import UserIcons from 'src/components/Elements/UserIcons'
import HorizontalLine from 'src/components/Elements/HorizontalLine'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import userStyles from './userStyles.module.scss'
import variables from 'src/assets/styles/variables.module.scss'

const UserDetailPage = () => {
  const navigate = useNavigate()
  const {
    currentEvent,
    currentUser,
    eventId,
    attendee,
    attendeeId,
    setSidePanelDetails
  } = useGlobalContext()
  const isApprovedInternal = useMemo(
    () => currentEvent.registration_status === 'Approved Internal',
    [currentEvent]
  )

  const handleMessageBtn = useCallback(() => {
    setSidePanelDetails({ type: 'message', data: Number(attendeeId) })
    navigate(`/programs/${eventId}/messages`)
  }, [eventId, attendeeId])

  const renderBizCardDetails = () => {
    if (attendee?.is_biz_card) {
      return (
        <div className={generalStyles.mt40}>
          <div>
            <span className={fontStyles.h5lsgraphik20pt}>Contact Details</span>
            <div className={classNames(generalStyles.mt10, generalStyles.mb20)}>
              <HorizontalLine color={'c03silvere8e8e8'} fullWidth={true} />
            </div>
          </div>
          <div className={generalStyles.mt10}>
            {attendee?.phone ? (
              <div className={generalStyles.flexRow}>
                <span className={fontStyles.psmalllsin08blackgraphik15pt}>
                  Phone |{' '}
                  <span className={fontStyles.psmallboldlsin08blackgraphik15pt}>
                    {attendee.phone}
                  </span>
                </span>
              </div>
            ) : null}
            {attendee?.email ? (
              <div className={generalStyles.flexRow}>
                <span className={fontStyles.psmalllsin08blackgraphik15pt}>
                  Email |{' '}
                  <span className={fontStyles.psmallboldlsin08blackgraphik15pt}>
                    {attendee.email}
                  </span>
                </span>
              </div>
            ) : null}
          </div>
        </div>
      )
    }
  }
  return (
    <div
      className={generalStyles.thirdWidth}
      data-testid="UserDetailPage"
    >
      <div className={userStyles.attendeeHeader}>
        <div className={classNames(generalStyles.flexRow, generalStyles.pt40)}>
          <UserImage
            photoUrl={attendee?.photo}
            styles={classNames(generalStyles.mr20, userStyles.image)}
            altText={`${attendee?.first_name} ${attendee?.last_name} Photo`}
          />
          <div className={generalStyles.flexColumn}>
            <div
              className={classNames(
                generalStyles.flexRow,
                generalStyles.mt05,
                generalStyles.mb05
              )}
            >
              <span className={fontStyles.h4lsgraphik23pt}>
                {attendee?.first_name} {attendee?.last_name}
              </span>
              <div
                className={classNames(
                  generalStyles.ml20,
                  generalStyles.flexRow
                )}
                style={{ alignItems: 'center' }}
              >
                <UserIcons user={attendee} data-testid="userIcons" />
              </div>
            </div>
            <div className={generalStyles.mb05}>
              <span className={fontStyles.h5lsin08blackgraphik20pt}>
                {attendee?.title}
              </span>
            </div>
            <div className={generalStyles.mb05}>
              <span className={fontStyles.h5lsin08blackgraphik20pt}>
                {attendee?.organization_name}
              </span>
            </div>
          </div>
        </div>
        {!isApprovedInternal && (
          <>
            <div className={classNames(generalStyles.mt10, generalStyles.mb10)}>
              <HorizontalLine data-testid="HorizontalLine" color={'c03silvere8e8e8'} fullWidth={true} />
            </div>
            <div
              className={classNames(
                generalStyles.flexRow,
                generalStyles.verticalAlign,
                generalStyles.pt05,
                generalStyles.pb05
              )}
            >
              <button
                data-title="Message"
                data-testid="messageBtn"
                className={userStyles.actionItemContainer}
                disabled={
                  !currentEvent?.is_attended ||
                  currentUser.id === parseInt(attendeeId)
                }
                onClick={() => handleMessageBtn()}
              >
                <IcomoonReact
                  icon={'Message'}
                  data-testid={'Symbol-MessageIcon-Medium-BlueOutline'}
                  iconSet={rebrandIconSet}
                  color={'#0000D3'}
                  size={23}
                />
              </button>
            </div>
          </>
        )}
        <div className={classNames(generalStyles.mt10, generalStyles.mb20)}>
          <HorizontalLine color={'c03silvere8e8e8'} fullWidth={true} />
        </div>
      </div>
      <div>
        <span className={fontStyles.h5lsgraphik20pt}>Biography</span>
        <div className={classNames(generalStyles.mt10, generalStyles.mb20)}>
          <HorizontalLine color={'c03silvere8e8e8'} fullWidth={true} />
        </div>
        <span className={fontStyles.psmalllsin08blackgraphik15pt}>
          {attendee?.bio || 'No bio provided'}
        </span>
      </div>
      {renderBizCardDetails()}
    </div>
  )
}

export default UserDetailPage
